module.exports = __webpack_public_path__ + "static/media/JD-download.be76da3b.gif";